import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Close from '@mui/icons-material/Close';
import { useSnackbar as useNotistackSnackbar, } from 'notistack';
import { useSnackbarConfig } from './snackbar-provider';
/**
 * Create a snackbar with the given options.
 * Use in conjunction with <SnackbarProvider/> in your app.
 */
export function useSnackbar(defaultOptions) {
    const { enqueueSnackbar, closeSnackbar } = useNotistackSnackbar();
    const { defaultErrorMsg } = useSnackbarConfig();
    const SnackbarDismissAction = (key) => (_jsx(Close, { className: "cursor-pointer", onClick: () => closeSnackbar(key) }));
    function addSnackbar(variant) {
        return (options) => {
            const { message = defaultErrorMsg ??
                "Oops! That's not supposed to happen. Please try again in a few seconds.", persist, code, ...restOptions } = {
                ...defaultOptions,
                ...options,
            };
            const finalPersist = persist == null ? variant === 'error' : persist;
            const codeSuffix = code ? ` Code: ${code}` : '';
            return enqueueSnackbar(message + codeSuffix, {
                key: code || undefined,
                variant,
                persist: finalPersist,
                preventDuplicate: variant === 'error',
                action: finalPersist ? SnackbarDismissAction : null,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: variant === 'default' ? 'center' : 'right',
                },
                ...restOptions,
            });
        };
    }
    return {
        close: closeSnackbar,
        info: addSnackbar('info'),
        success: addSnackbar('success'),
        error: addSnackbar('error'),
        default: addSnackbar('default'),
        custom: (v, options) => addSnackbar(v)(options),
    };
}
